var _effectorFileName = "/src/shared/components/cookie-banner/cookie-banner.tsx";
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'next-i18next';
import { Button } from '../ui/button';
interface CookieConsentProps {
  onConsentChange: (consent: boolean) => void;
}
const CookieConsent = (props: CookieConsentProps) => {
  const {
    onConsentChange
  } = props;
  const {
    t
  } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const cookieConsent = Cookies.get('cookie_consent');
    if (!cookieConsent) {
      setIsVisible(true);
    } else {
      onConsentChange(cookieConsent === 'accepted');
    }
  }, [onConsentChange]);
  const handleAccept = () => {
    Cookies.set('cookie_consent', 'accepted', {
      expires: 365
    });
    onConsentChange(true);
    setIsVisible(false);
  };
  const handleReject = () => {
    Cookies.set('cookie_consent', 'rejected', {
      expires: 365
    });
    onConsentChange(false);
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border/40 bg-background/95 p-4 py-4 text-white backdrop-blur supports-[backdrop-filter]:bg-background/10">
      <div className="mx-auto flex max-w-4xl flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
        <p className="text-sm text-black dark:text-white">
          {t('cookieBanner.text')}{' '}
          <a href="/privacy-policy" className="text-brand-accent-light underline">
            {t('cookieBanner.privacyPolicy')}
          </a>
          .
        </p>
        <div className="flex space-x-2">
          <Button onClick={handleAccept} className="bg-blue-700 dark:bg-blue-600 dark:text-white">
            {t('cookieBanner.accept')}
          </Button>
          <Button onClick={handleReject} variant="outline" className="text-gray-400 hover:bg-black/50 hover:text-muted-foreground">
            {t('cookieBanner.reject')}
          </Button>
        </div>
      </div>
    </div>;
};
export default CookieConsent;